"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Time = function Time(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 26 26",
    width: "26",
    height: "26"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.0833333333333333,0,0,1.0833333333333333,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12C23.993,5.376,18.624,0.007,12,0z M17.2,17.221 c-0.377,0.399-1.003,0.426-1.413,0.062l-4.959-4.546C10.62,12.548,10.501,12.281,10.5,12V6.5c0-0.552,0.448-1,1-1s1,0.448,1,1v5.06 l4.634,4.248c0.409,0.372,0.439,1.004,0.067,1.413C17.201,17.221,17.2,17.222,17.2,17.221L17.2,17.221z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Time.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Time.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Time;